//标准例，这里是标准的app端api处理
//每个业务对应一个js,比如说用户相关的全放在一个文件里
//这个文件只是例子。函数首字母大写，与页面内部的函数相区别
//需要用时，直接从页面引入!

import { BASE_URL } from '@/services/api'
import {request, METHOD} from '@/utils/request'


let STAND_LIST=`${BASE_URL}/standlist`

export async function GetStandList(params) {
  return request(STAND_LIST, METHOD.POST, params)
}

export default {
  GetStandList,
}
